import {
  SAVE_APP_SETTINGS_FAILURE,
  SAVE_APP_SETTINGS_SUCCESS,
  SAVE_APP_SETTINGS_REQUEST,
  FETCH_APP_SETTINGS_REQUEST,
  FETCH_APP_SETTINGS_SUCCESS,
  FETCH_APP_SETTINGS_FAILURE,
  FETCH_APP_SETTINGS_COMPLETE_REQUEST,
  FETCH_APP_SETTINGS_COMPLETE_SUCCESS,
  FETCH_APP_SETTINGS_COMPLETE_FAILURE,
  FETCH_SIMPLE_APP_SETTINGS_LIST_PDF_REQUEST,
  FETCH_SIMPLE_APP_SETTINGS_LIST_PDF_SUCCESS,
  FETCH_SIMPLE_APP_SETTINGS_LIST_PDF_FAILURE,
} from '../types';

const INITIAL_STATE = {
  appSettings: null,
  appSettingsComplete: null,
  appSettingsImageUrl: '',
  loading: false,
  error: null,
  simplepAppSettingsList: null,
  simplepAppSettingsListLoading: false,
  custompAppSettingsList: null,
  custompAppSettingsListLoading: false,
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case SAVE_APP_SETTINGS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case SAVE_APP_SETTINGS_SUCCESS:
      return {
        ...state,
        loading: false,
      };
    case SAVE_APP_SETTINGS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload.error,
      };
    case FETCH_APP_SETTINGS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case FETCH_APP_SETTINGS_SUCCESS:
      return {
        ...state,
        loading: false,
        appSettings: action.payload,
      };

    case FETCH_APP_SETTINGS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload.error,
        appSettings: null,
      };
    case FETCH_APP_SETTINGS_COMPLETE_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case FETCH_APP_SETTINGS_COMPLETE_SUCCESS:
      return {
        ...state,
        loading: false,
        appSettingsComplete: action.payload,
      };

    case FETCH_APP_SETTINGS_COMPLETE_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload.error,
        appSettingsComplete: null,
      };
    case FETCH_SIMPLE_APP_SETTINGS_LIST_PDF_REQUEST:
      return {
        ...state,
        simplepAppSettingsListLoading: true,
        error: null,
      };

    case FETCH_SIMPLE_APP_SETTINGS_LIST_PDF_SUCCESS:
      return {
        ...state,
        simplepAppSettingsListLoading: false,
        simplepAppSettingsList: action.payload,
      };

    case FETCH_SIMPLE_APP_SETTINGS_LIST_PDF_FAILURE:
      return {
        ...state,
        simplepAppSettingsListLoading: false,
        error: action.payload.error,
        simplepAppSettingsList: null,
      };

    default:
      // ALWAYS have a default case in a reducer
      return state;
  }
};
